import React, { useState, useEffect } from 'react';

import { IComponentRadio } from '../../component.d';
import { RenderRequired } from './Form';

const AllForFormRadio = function(props: IComponentRadio) {
  const {
    field,
    align,
    width,
    onChange,
    required,
    select,
    label,
    type
  } = props;

  const [data, setData] = useState('');

  return (
    <div className="all-for-input">
      <div className="weui-cells__group weui-cells__group_form">
        {label ? (
          <div className="weui-cells__title">
            {field} {RenderRequired(required)}
          </div>
        ) : null}
        <div className="weui-cells weui-cells_radio">
          {select.map((it: string, index: number) => {
            return (
              <label
                key={it + index}
                className="weui-cell weui-cell_active weui-check__label"
                onClick={() => {
                  setData(it);
                  onChange(type, field, it);
                }}
              >
                <div className="weui-cell__bd">
                  <p>{it}</p>
                </div>
                <div className="weui-cell__ft">
                  <input
                    type="radio"
                    name={field}
                    className="weui-check"
                    checked={data == it}
                    readOnly
                  />
                  {data == it ? (
                    <span className="weui-icon-checked"></span>
                  ) : null}
                </div>
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AllForFormRadio;
